/**
 * @description The status of the event order, Cancelled, Confirmed, Created, etc.
 */
export enum OrderEventStatusType {
  Cancelled = 'Cancelled',
  Confirmed = 'Confirmed',
  Created = 'Created',
  Paid = 'Paid',
  Sent = 'Sent',
  Expired = 'Expired',
  ConfirmationExpired = 'ConfirmationExpired',
  Refunded = 'Refunded',
}



// WEBPACK FOOTER //
// ./src/model/types/order-event-type.ts